import { useState } from "react";
import styled from "styled-components";
import NovaIcon from "../assets/images/logo/tokens/nova.png";
import CptIcon from "../assets/images/logo/tokens/cpt.png";
import PlusIcon from "../assets/icons/plus.svg";
import MinusIcon from "../assets/icons/minus.svg";
import { FlexContainer } from "./styled";

const MarketItem = ({product,handleBasket,novaPrice}) => {
    const [quantity, setQuantity] = useState(0);
    // const {name, price, image,description} = product;
    const handleAmountChange = (type) => {
        let val = quantity;
        if(isNaN(val) || val === "") {
            val = 0;
        }
      
        if(type === "minus" && quantity > 0) {
           let res = handleBasket(product,"remove");
           if(res) {
                setQuantity(quantity - 1);
            }
            return;
        }
        if(type === "plus") {
            let res = handleBasket(product,"add");
            if(res){
                setQuantity(quantity + 1);
            }
            
            return;
        }
    }
    const handleCustomAmount = (e) => {
        let value = e.target.value;
        // if(isNaN(value) || value === "") {
        //     value = 0;
        // }
        // if(value < 0 || value === "") {
        //     setQuantity(0);
        //     return;
        // }
        if(value > product?.item?.maxAmount) {
            setQuantity(product?.item?.maxAmount);
            return;
        }

        setQuantity(value);
        if(value === "" ){
            value = 0;
        }
        handleBasket(product,"custom",value);
    }
    return (
        <MarketItemContainer>
            <ItemImageArea>
                <img src={product?.item.imageUri} alt={product?.item?.name} />
                <span>{product?.item?.name}</span>
            </ItemImageArea>
            <FlexContainer style={{marginTop: "8px",textAlign: "center",fontSize: "12px",color: "white",padding: "8px 0"}}>
                {product?.item?.description}
            </FlexContainer>
            <FlexContainer gap="8px" style={{margin: "12px 0"}}>
                <img style={{width:"21px"}} src={product.currency.symbol === "CPT" ? CptIcon : NovaIcon} alt="Nova Icon" />
                <span style={{color: "white",fontSize: "22px",fontWeight:600}}>{novaPrice ? (product?.priceInUsd / novaPrice).toFixed(0) : 0}</span>
            </FlexContainer>
            <FlexContainer style={{justifyContent: "space-around", marginBottom: "8px",padding: "0 8px"}}>
                <IconButton onClick={()=>handleAmountChange("minus")} ><img src={MinusIcon} alt="Minus Icon" /></IconButton>
                <AmountInput type="number" onChange={handleCustomAmount} value={quantity}/>
                <IconButton onClick={()=>handleAmountChange("plus")} ><img src={PlusIcon} alt="Plus Icon" /></IconButton>
            </FlexContainer>
        </MarketItemContainer>
    );
};

const MarketItemContainer = styled.div`
    background: #111F2E59;
    background-blend-mode: overlay;
  background: linear-gradient(
  180deg,
  #1c3d6d 0%, /* Üstte daha açık mavi */
rgba(5, 30, 57, 0.65) 100% /* Altta daha koyu mavi */
);
    max-width: 100%;
    /* aspect-ratio:174/343; */
    border-radius: 21px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
`
const ItemImageArea = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(
  180deg,
rgba(51, 96, 164, 0.66) 0%, /* Üstte daha açık mavi */
  #0b2b53 100% /* Altta daha koyu mavi */
);
  border-radius: 16px;
  /* aspect-ratio: 1/1; */
  flex-direction: column;
  padding: 0;
  padding-bottom: 8px;
  img{
    width: 100%;
    margin-bottom: 12px;
  }
  span{
    font-size:16px;
    color: white;
    text-align: center;
    padding:4px 8px;
  }
`
const IconButton =styled.span`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #003557;
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%), #003557;
    background-blend-mode: overlay;
    box-shadow: 0px 1.75px 2.19px 0px #0000001F;
    width: 40px;
    height: 20px;
    border-radius: 59px;    
    img{
        width: 10px;
    }
`
const AmountInput = styled.input`
    width: 50px;
    height: 25px;
    border: none;
    outline: none;
    background: #003557;
    border-radius: 59px;
    color: white;
    text-align: center;
    background: #63636333;
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    text-align: center;
    appearance: textfield;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`

export default MarketItem;